import React from 'react';

function Settings() {
    return (
        <div className='title'>
            <h1> Réglages </h1>
        </div>
    );
}

export default Settings;